import React, { useEffect } from 'react';
import ContactUs from '../components/ContactUs';

export default function ContactPage() {
  useEffect(() => {
    document.title = 'Contact Us | Savana Sips';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-enter" style={{ paddingTop: '60px', backgroundColor: '#2B1509', minHeight: 'calc(100vh - 200px)' }}>
      <ContactUs />
    </div>
  );
}
